import { cn } from "../../lib/utils";

const sizes = {
  sm: "h-4 w-4",
  md: "h-5 w-5",
  lg: "h-6 w-6"
};

export function Spinner({ size = "md", className = "" }) {
  return (
    <svg
      className={cn("animate-spin text-current", sizes[size] || sizes.md, className)}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" className="opacity-25" stroke="currentColor" strokeWidth="3" />
      <path
        className="opacity-90"
        fill="currentColor"
        d="M22 12a10 10 0 0 0-10-10v3a7 7 0 0 1 7 7h3Z"
      />
    </svg>
  );
}
